import React from 'react';
import { MicIcon } from 'lucide-react';
import { books } from '../data/profile';
export function Publications() {
  return <section className="bg-white py-16 lg:py-24" data-id="element-169" data-mp="3lhlvfr5qqat8">
      <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-170" data-mp="36u0r5tx4q5jq">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-171" data-mp="36thk5890p1kh">
          <div className="max-w-2xl" data-id="element-172" data-mp="3brst7grhn81n">
            <h2 className="font-serif text-3xl leading-tight text-navy sm:text-4xl" data-id="element-173" data-mp="3bqr80jgrd567">
              Published author and thought leader on leadership under pressure.
            </h2>
          </div>
          <div className="inline-flex items-center gap-3 border border-mist bg-offwhite px-5 py-3" data-id="element-174" data-mp="32q2tzord74tb">
            <MicIcon className="h-5 w-5 text-gold-deep" aria-hidden="true" data-id="element-175" data-mp="2nxj4hqx50vuc" />
            <span className="text-sm font-semibold text-navy" data-id="element-176" data-mp="2suhvi0li8mob">
              Represented by Worldwide Speakers Group
            </span>
          </div>
        </div>

        <ul className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-177" data-mp="r1tpjjhh7l4u">
          {books.map(book => <li key={book.title} className="flex" data-id="element-178" data-mp="cell0m6f8ngj">
              <article className="flex w-full flex-col border border-mist" data-id="element-179" data-mp="cdalwznx83vr">
                <img src={book.cover} alt={`Cover of ${book.title}`} className="aspect-[3/4] w-full object-cover" loading="lazy" data-id="element-180" data-mp="7fr3dnk6x4y0" />
                <div className="flex flex-1 flex-col p-6" data-id="element-181" data-mp="h86lckvhltiw">
                  <span className="text-[11px] font-semibold uppercase tracking-overline text-slate-400" data-id="element-182" data-mp="3pmyf3xzfwu2e">
                    {book.year}
                  </span>
                  <h3 className="mt-3 font-serif text-xl leading-snug text-navy" data-id="element-183" data-mp="2gxr1ygn3jzf">
                    {book.title}
                  </h3>
                  <p className="mt-1 text-sm font-medium text-gold-deep" data-id="element-184" data-mp="3uk70e7fvxe7v">
                    {book.subtitle}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-charcoal" data-id="element-185" data-mp="1dyfn0brzbfbe">
                    {book.description}
                  </p>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}